import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Plus, X } from "lucide-react";

interface AddSubsectionRowProps {
    sectionId: string;
    onAddSubsection: (sectionId: string, subsection: PolicyFormSubSection) => void;
}

export function AddSubsectionRow({ sectionId, onAddSubsection }: AddSubsectionRowProps) {
    const [showAddRow, setShowAddRow] = useState(false);
    const [title, setTitle] = useState("");

    const onToggleShow = () => {
        setShowAddRow(prev => !prev);
    }

    const handleSave = () => {
        const newSubsection: PolicyFormSubSection = {
            id: title.toLowerCase().replace(/\s+/g, "-"),
            title,
            questionGroups: [],
        };

        onAddSubsection(sectionId, newSubsection);
        onToggleShow();
    };

    if (!showAddRow) {
        return (
            <Button size="sm" variant="outline" onClick={onToggleShow}>
                <Plus size={16} className="mr-1" /> Add Subsection
            </Button>
        )
    }

    return (
        <Card className="p-4 border shadow-sm rounded-lg bg-gray-50 space-y-4">
            <div className="grid grid-cols-3 gap-4">
                <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Subsection Title"
                    className="col-span-1 text-sm border-b border-transparent focus:border-gray-400 outline-none bg-transparent"
                />
            </div>

            <div className="flex justify-end gap-2">
                <Button size="sm" onClick={handleSave}>
                    <Plus size={12} className="mr-1" /> Save Subsection
                </Button>
                <Button size="sm" variant="destructive" onClick={onToggleShow}>
                    <X size={12} className="mr-1" /> Cancel
                </Button>
            </div>
        </Card>
    );
}